import { render, staticRenderFns } from "./EtapaCasoListView.vue?vue&type=template&id=6f667fbf"
import script from "./EtapaCasoListView.vue?vue&type=script&lang=js"
export * from "./EtapaCasoListView.vue?vue&type=script&lang=js"
import style0 from "./EtapaCasoListView.vue?vue&type=style&index=0&id=6f667fbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports